'use es6';

import Immutable from 'immutable';
import { cleanObject } from 'ecosystem-marketplace-core/utils/formatters';
import ThemeContentItem from './ThemeContentItem';
const EMPTY_LIST = Immutable.List();
const defaults = {
  bucketKey: '',
  contents: EMPTY_LIST,
  createdAt: 0,
  id: 0,
  portalId: 0,
  scopes: null,
  themePath: ''
};

class ThemeContentsResponse extends Immutable.Record(defaults) {
  constructor(json = {}) {
    const jsonCopy = Object.assign({}, json);

    if (json.contents) {
      jsonCopy.contents = Immutable.List(json.contents.map(contentItem => new ThemeContentItem(contentItem)));
    }

    if (json.scopes) {
      jsonCopy.scopes = Immutable.Set(json.scopes);
    }

    super(cleanObject(jsonCopy));
  }

}

export default ThemeContentsResponse;